import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";
import {
  BotMessageListFn,
  PatchChatAgentQAFn,
  PostChatAgentQAFn,
  UnmatchedListFn,
} from "../../../../Services/ChatAgent";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const VARIABLES = [
  "ORDER_NO",
  "ORDER_DATE",
  "ORDER_AMOUNT",
  "ORDER_STATUS",
  "PAYMENT_STATUS",
  "STORE_NAME",
  "ITEM_NAME",
  "ITEM_QTY",
  "ITEM_PRICE",
  "USER_NAME",
  "USER_MOBILE",
  "USER_EMAIL",
  "USER_DOB",
];

const PRESET_QUESTIONS = [
  "Order Items",
  "Order",
  "Profile",
  "Order Status",
  "Custom",
];

const AddQuestionAnswer = () => {
  const [questionType, setQuestionType] = useState("Custom");
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [keywordInput, setKeywordInput] = useState("");
  const [keywords, setKeywords] = useState([]);
  const [loading, setLoading] = useState(false);

  const { type } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (state) {
      setQuestion(state?.question || "");
      setAnswer(state?.answer || "");
      setKeywords(state?.keywords || []);
    }
  }, [state]);

  // Insert variable inside answer at cursor position
  const insertVariable = (variable) => {
    const textarea = document.getElementById("answerBox");
    if (!textarea) return;

    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;

    const before = answer.substring(0, start);
    const after = answer.substring(end);

    const updated = before + `{{${variable}}}` + after;

    setAnswer(updated);

    setTimeout(() => {
      textarea.focus();
      textarea.selectionStart = textarea.selectionEnd =
        start + variable.length + 4;
    }, 50);
  };

  const handleAddKeyword = () => {
    if (keywordInput.trim() !== "") {
      setKeywords([...keywords, keywordInput.trim()]);
      setKeywordInput("");
    }
  };

  const handleRemoveKeyword = (index) => {
    setKeywords(keywords.filter((_, i) => i !== index));
  };

  const { mutate: AddQa, isLoading } = useMutation(PostChatAgentQAFn, {
    onSuccess: (res) => {
      if (res?.data?.response_code === 200) {
        toast.success(res?.data?.message);
        navigate(-1);
      } else {
        toast.warn(res?.data?.message);
      }
    },
  });

  const { mutate: UpdateQa, isLoading: UpdateLoading } = useMutation(
    PatchChatAgentQAFn,
    {
      onSuccess: (res) => {
        if (res?.data?.response_code === 200) {
          toast.success(res?.data?.message);
          navigate(-1);
        } else {
          toast.warn(res?.data?.message);
        }
      },
    }
  );

  const handleSubmit = () => {
    if (!question || !answer) {
      toast.warn("Question and Answer are required");
      return;
    }

    const payload = {
      question,
      answer,
      keywords,
      store: localStorage.getItem("store_id"),
    };

    if (type === "add") AddQa(payload);
    else UpdateQa({ ...payload, qa_id: state?.id });
  };

  useEffect(() => {
    if (questionType !== "Custom") {
      setQuestion(questionType);
    }
  }, [questionType]);

  const { data, refetch } = useQuery(["bot_messages"], () =>
    BotMessageListFn({
      store_id: localStorage.getItem("store_id"),
      for_chat: "true",
    })
  );

  const { data:unMatched } = useQuery(["unmatched"], () =>
    UnmatchedListFn({ store_id: localStorage.getItem("store_id") })
  );


  return (
    <div className="max-w-4xl mx-auto p-5 border rounded-lg shadow-sm space-y-4">
      <h2 className="text-xl font-bold capitalize">{type} Question & Answer</h2>

      {/* Question type selector */}
      <div>
        <label className="font-semibold">Select Question Type</label>
        <select
          className="w-full border p-2 rounded text-black mt-1"
          value={questionType}
          onChange={(e) => setQuestionType(e.target.value)}
        >
          {PRESET_QUESTIONS.map((q, idx) => (
            <option key={idx} value={q}>
              {q}
            </option>
          ))}
        </select>
      </div>

      {/* If not custom, auto fill */}
      {questionType !== "Custom" ? (
        <div>
          <label className="font-semibold">Question</label>
          <input
            type="text"
            className="w-full border p-2 rounded mt-1 text-black"
            value={questionType}
            readOnly
          />
        </div>
      ) : (
        <div>
          <label className="font-semibold">Write Custom Question</label>
          <input
            type="text"
            className="w-full border p-2 rounded mt-1 text-black"
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            placeholder="Enter your question"
          />
        </div>
      )}

      {/* Variables section */}
      <div>
        <label className="font-semibold">Variables</label>

        <span className="text-[10px]">
          (Click a variable to automatically insert it into the answer)
        </span>

        <div className="flex flex-wrap gap-2 mt-2">
          {VARIABLES.map((v, idx) => (
            <button
              key={idx}
              onClick={() => insertVariable(v)}
              className="px-2 py-1 bg-blue-100 text-black rounded text-sm border"
            >
              {v}
            </button>
          ))}
        </div>
      </div>

      {/* Answer box */}
      <div>
        <label className="font-semibold">Answer</label>
        <textarea
          id="answerBox"
          className="w-full border p-2 rounded mt-1 text-black"
          rows="4"
          value={answer}
          onChange={(e) => setAnswer(e.target.value)}
          placeholder="Enter answer"
        />
      </div>

      <label className="font-semibold">Select Chat Message Question</label>
      <select
        className="w-full border p-2 rounded text-black mt-1"
        onChange={(e) => {
          const value = e.target.value;
          if (value.trim() !== "" && !keywords?.includes(value)) {
            setKeywords((prev) => [...prev, value]);
          }
        }}
      >
        <option value={""}>Select A Option</option>
        {data?.data?.data?.map((q, idx) => (
          <option key={idx} value={q.question}>
            {q?.question}
          </option>
        ))}
      </select>


      <label className="font-semibold">Select UnMatched Question</label>
      <select
        className="w-full border p-2 rounded text-black mt-1"
        onChange={(e) => {
          const value = e.target.value;
          if (value.trim() !== "" && !keywords?.includes(value)) {
            setKeywords((prev) => [...prev, value]);
          }
        }}
      >
        <option value={""}>Select A Option</option>
        {unMatched?.data?.data?.map((q, idx) => (
          <option key={idx} value={q.question}>
            {q?.question}
          </option>
        ))}
      </select>
      

      <div>
        <label className="font-semibold">Keywords</label>
        <div className="flex gap-2 mt-1">
          <input
            type="text"
            className="flex-1 border p-2 rounded text-black"
            value={keywordInput}
            onChange={(e) => setKeywordInput(e.target.value)}
            placeholder="Type keyword & press Enter"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleAddKeyword();
              }
            }}
          />

          <button
            onClick={handleAddKeyword}
            className="bg-blue-600 text-white px-4 py-2 rounded"
          >
            Add
          </button>
        </div>

        <div className="flex flex-wrap gap-2 mt-3">
          {keywords.map((kw, index) => (
            <span
              key={index}
              className="bg-gray-200 px-3 py-1 text-black rounded text-sm flex items-center gap-2"
            >
              #{kw}
              <button
                onClick={() => handleRemoveKeyword(index)}
                className="text-red-600 font-bold"
              >
                ×
              </button>
            </span>
          ))}
        </div>
      </div>

      <button
        onClick={handleSubmit}
        className="w-full bg-green-600 text-white py-2 rounded font-semibold"
        disabled={UpdateLoading || isLoading}
      >
        {UpdateLoading || isLoading ? "Saving..." : "Save QA"}
      </button>
    </div>
  );
};

export default AddQuestionAnswer;
